import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthenticationService } from '@core/services';
import { UserType } from '@core/interfaces';
import { BusinessRoutePaths } from '@core/configs/route-paths';


@Injectable({ providedIn: 'root' })
export class HomeGuard  {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        const currentUser = this.authenticationService.currentUserValue;
        const currentUserActiveType = this.authenticationService.currentUserActiveType;
        if (currentUser) {
            if (currentUserActiveType === UserType.Business) {
                return this.router.createUrlTree([BusinessRoutePaths.root]);
            }
        }
        return true;
    }
}
